(async () => {
    const { Core } = await importModule('Core');
    const { cartProvider } = await importModule('Utils');
    const EL_PARENT = '[data-cart-item]';
    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_LINE_KEY = 'line';
    
    class CartControl extends Core {
        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }
        
        get $parentItem() {
            return this.closest(EL_PARENT);
        }

        get line() {
            return this.getAttribute(ATTR_LINE_KEY)
        }
        get dataAdditionalVariant() {
            return this.getAttribute("data-additional-variant");
        }

        parentLoading() {
            this.$parentItem?.classList.add(CN_LOADING);
        }
    }

    customElements.define('cart-qty-button', class extends CartControl {
        
        render() {
            this.addEventListener('click', this._onQtyChange.bind(this), { once: true });
        };

        _onQtyChange(e) {
            e.preventDefault();

            this.parentLoading();

            cartProvider(this)
                .update(
                    this.variantId, 
                    this.value,
                    this.sellingPlanId,
                    this.line,
                    this.dataAdditionalVariant
                );
        };

        get value() {
            return this.getAttribute('set-value');
        }
    });

    customElements.define('cart-qty-input', class extends CartControl {

        render() {
            this.addEventListener('change', this._onQtyChange.bind(this), { once: true });
        };

        _onQtyChange(e) {
            this.parentLoading();

            cartProvider(this)
                .update(
                    this.variantId, 
                    e.target.value,
                    this.sellingPlanId,
                    this.line,
                    this.dataAdditionalVariant
                );
        };
    });
})();